import script from "./StepWebsite.vue?vue&type=script&setup=true&lang=js"
export * from "./StepWebsite.vue?vue&type=script&setup=true&lang=js"

import "./StepWebsite.vue?vue&type=style&index=0&id=5f529d7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f529d7d"]])

export default __exports__